<template>
    <div class="row box">
        <div
            class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-center">
            <div class="img">
                <img v-if="product.IMAGE > 0"
                    class="img-responsive center-block prodBoxImg"
                    :src="'https://campbellsci-res.cloudinary.com/image/upload/f_auto,c_limit,w_150,h_150/'+product.IMAGE+'.png'"
                    :alt="product.PROD_MODEL" />
                <i v-if="!product.IMAGE > 0"
                    class="csi-iconfont csi-logo noimg"></i>
            </div>
        </div>

        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <slot></slot>
            <product-box-options v-if="type == 'main' && !product.RETIRED" :product="product"></product-box-options>
        </div>
        <order-actions :product="product" :main="type == 'main'"></order-actions>
    </div>
</template>

<script>
import orderActions from '../components/orderActions';
import productBoxOptions from '../components/productBoxOptions';

export default {
    name: 'productBox',
    components: {
        orderActions,
        productBoxOptions
    },
    props: {
        product: Object,
        type: String
    }
}
</script>
